<script>
  import {navigate} from 'svelte-routing'
  import LinkMolecule from '~/Components/Molecules/Link'
  import Layout from '~/Components/Layout/Layout'

  let slide = 0
  let content = [
    '<p>In business, decisions are made that don’t just impact the future of the organization, they impact individuals too.</p><p>When life throws twists and turns at us and when that path we set out on, for reasons not always within our control, changes, we need to learn how to react, course correct and re-evaluate.</p><p>Next4Me is our way of helping you continue your journey and get back on your path as quickly as possible.</p>',
    '<p>The “For you” and “For your career” pages offer learning, as well as opportunities to develop, grow and set your Next4Me career in motion.</p><p>You decide what you want to do next. The choices you make here are entirely up to you.</p>'
  ]

  let titles = [
    'Life is unpredictable',
    'What’s Next?',
  ]

  function next(){
    if (!slide){
      slide = 1
    } else {
      navigate('/for-you', { replace: true })
    }
  }
</script>

<Layout>

  <div class="onboarding">

    <div class="onboarding__left">

      <h1 class="heading">{titles[slide]}</h1>

      <div class="onboarding__content">

        {@html content[slide]}

      </div>

      <LinkMolecule cta="{slide === 0 ? 'Next' : 'Go'}" callback={next} />

    </div>

    <div class="onboarding__image">

      <img class="onboarding__illustration" src="static/illustrations/working.svg" alt="">

      <img class="onboarding__background" src="static/shapes/rectangle.svg" alt="">

    </div>

  </div>

</Layout>

<style lang="scss">

  .onboarding {

    $this: &;

    display: flex;
    position: relative;
    padding: 8.625rem 0;

    &__left {
      flex-basis: 60%;
      margin-right: 3.75rem;
      h1.heading {
        font-weight: 800;
        font-size: 5rem;
        margin-bottom: 1.875rem;
      }
    }
    &__image {
      position: relative;
      flex-basis: 40%;
    }
    &__background {
      position: absolute;
      height: 55rem;
      width: 55rem;
      bottom: -100px;
      left: 0;
      z-index: -10;
    }

    @media only screen and (max-width: 576px) {
      flex-direction: column-reverse;
      padding: 2rem 0;
      &__image img {
        height: 15rem;
      }
      &__left {
        margin: 1rem 0rem;
        h1.heading {
          font-size: 2.625rem;
          line-height: 3.5rem;
        }
      }
    }

  }

  :global(.onboarding__content p) {
    margin-bottom: 1rem;
    line-height: 150%;
    &:last-of-type {
      margin-bottom: 1.875rem;
    }
  }

</style>
